export default "__VITE_ASSET__JjDYqDRD__"